<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">메시지 발송</span>
            <span class="txt">회원에게 메시지를 발송/예약할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <button @click="onClickRouter('/madmin/message/send')">SMS(문자메시지)</button>
            <button @click="onClickRouter('/madmin/message/send/alert')">알림톡</button>
            <button class="on">SMS/알림톡 자동 발송</button>
        </div>

        <div class="com-info-wrap">
            <div class="tit">
                <span>자동 치환 문자 안내</span>
                <div class="com-tooltip">
                    <button class="icon"></button>
                    <div class="detail">
                        <span class="tit">이용권 결제등록 완료시점에 자동발송 됩니다.</span>
                        <p class="txt">
                            <span class="red">[추가 사용 가능한 치환문자]</span>
                            <br />
                            #{담당강사} : 이용권의 지정된 담당강사
                            <br />
                            #{이용권명} : 이용권명
                            <br />
                            #{유효기간} : (예시 : 2020-01-01 ~ 2020-02-28)
                        </p>
                    </div>
                </div>
            </div>
            <div class="com-info-cont-list">
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{회원명}</span>
                    <dd>회원 이름</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{이용권명}</span>
                    <dd>이용권명</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{센터명}</span>
                    <dd>센터명 ({{ centerInfo.centerName }})</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{센터번호}</span>
                    <dd>센터대표전화번호 ({{ centerInfo.telNo | phoneNumberFilter }})</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{유효기간}</span>
                    <dd class="w220">이용권 유효기간(YYYY-MM-DD ~ YYYY-MM-DD)</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{종료일}</span>
                    <dd>이용권 종료일</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{담당강사}</span>
                    <dd>이용권 지정 담당강사</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{강사명}</span>
                    <dd>예약된 수업의 강사명</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{강사번호}</span>
                    <dd>예약된 수업의 연락처</dd>
                </dl>
                <dl>
                    <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{수업일시}</span>
                    <dd>예약된 수업일시</dd>
                </dl>
            </div>
            <div class="com-sub-info-wrap">
                <ul>
                    <li>
                        ·SMS/알림톡 자동 발송 기능을 사용하기 위해서는 각 상황별 문자 설정이 ON(사용)으로 선택되어
                        있어야 합니다.
                    </li>
                    <li>·알림톡으로 자동 전송을 하기 위해서는 자동 문자, 알림톡 두개 모두 ON(사용) 상태여야 합니다.</li>

                    <li>
                        ·알림톡은 한글로 최대 1,000자까지 템플릿 등록이 가능하며, 등록된 템플릿은 최종 승인 처리가
                        되어야 발송이 가능합니다.
                    </li>
                </ul>
                <ul>
                    <li>
                        · 치환 문자 클릭 시 자동으로 복사가 되며, 메시지 작성 입력란에서 바로 붙여 넣기를 하실 수
                        있습니다.
                    </li>
                    <li>
                        · SMS/알림톡 발송 시
                        <span class="txt-blue">#{회원명}, #{센터번호}</span>
                        등의 치환 문구를 삽입할 경우 등록된 회원 및 데이터에 따라 자동 적용(변경)되어 발송됩니다.
                    </li>
                </ul>
            </div>
        </div>

        <div class="com-cont-wrap">
            <p class="sub-title small">발송 정보</p>
            <div class="com-card-input full">
                <div class="line">
                    <span class="tit">
                        발신번호
                        <span class="require">*</span>
                    </span>
                    <div class="input-cnt">
                        <div id="dropdown" class="dropdown" @click="toggleDropdown">
                            <div
                                class="dropdown-selected"
                                :class="{ highlight: selectedNumber && selectedNumber.is_present }"
                            >
                                <span v-if="selectedNumber">
                                    {{ selectedNumber.label }} {{ selectedNumber.value | phoneNumberFilter }}
                                </span>
                                <span
                                    v-if="selectedNumber && selectedNumber.is_present"
                                    class="highlight"
                                    :style="{ backgroundColor: '#4780fd', color: 'white' }"
                                >
                                    대표
                                </span>
                                <span class="arrow down"></span>
                            </div>
                            <div class="dropdown-content" v-if="isOpen">
                                <div
                                    v-for="option in options"
                                    :key="option.value"
                                    class="dropdown-option"
                                    :class="{ highlight: isHighlighted(option) }"
                                    @click="selectOption(option, $event)"
                                >
                                    <span>{{ option.label }} {{ option.value | phoneNumberFilter }}</span>
                                    <span
                                        v-if="option.is_present"
                                        class="highlight"
                                        :style="{ backgroundColor: '#4780fd', color: 'white' }"
                                    >
                                        대표
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom-btn">
                    <button class="com-btn">취소</button>
                    <button class="com-btn blue" @click="saveNumber">저장</button>
                </div>
            </div>
        </div>

        <div class="com-cont-wrap">
            <p class="sub-title small">자동 발송 메시지</p>

            <ul class="auto-send-msg">
                <li>
                    <div class="accordion-tit" @click="isAccordion1Open = !isAccordion1Open">
                        <span>이용권 결제 / 예약 안내</span>
                        <span class="ico-arrow" :class="{ on: isAccordion1Open, off: !isAccordion1Open }"></span>
                    </div>
                    <div class="accordion-desc" :class="{ on: isAccordion1Open, off: !isAccordion1Open }">
                        <div class="phone-list">
                            <!-- CASE 1 -->
                            <div class="phone-item">
                                <div class="top-area">
                                    <div class="line">
                                        <span class="tit">
                                            <span>결제 등록</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    id="check-sms-1-1"
                                                    name="check-sms-1-1"
                                                    type="checkbox"
                                                    v-model="payPost.useYn"
                                                />
                                                <label for="check-sms-1-1"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <span class="tit">
                                            <span>알림톡 사용</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`check-kakao-1-1`"
                                                    :name="`check-kakao-1-1`"
                                                    type="checkbox"
                                                    v-model="isCheckedKakao[0]"
                                                    :disabled="isToggleDisabled"
                                                />
                                                <label :for="`check-kakao-1-1`"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <select-form
                                    v-if="isCheckedKakao[0]"
                                    :select-data="['선택', ...templateList.map((template) => template.title)]"
                                    :select-value="['선택', ...templateList.map((template) => template.id)]"
                                    :selected-value="payPost.template"
                                    @update:set="(templateId) => onChangeKakaoTemplate(templateId, 'payPost')"
                                ></select-form>

                                <div class="com-phone-sms other">
                                    <textarea
                                        :value="payPost.content"
                                        @input="isCheckedKakao[0] ? null : fnChkByte(payPost, $event)"
                                        :readonly="isCheckedKakao[0]"
                                        placeholder="#{회원명}님 #{이용권명}이 #{유효기간}이결제 되었습니다.감사합니다."
                                    ></textarea>
                                    <div class="info-line">
                                        <span class="num">{{ byteCalculator(payPost.content) }}</span>
                                        / 2000 byte
                                    </div>
                                </div>
                                <button class="com-btn" @click="tryMessageTemplate(payPost, 'PRG', 0, 'PRG')">
                                    저장
                                </button>
                            </div>
                            <!-- CASE 2 -->
                            <div class="phone-item">
                                <div class="top-area">
                                    <div class="line">
                                        <span class="tit">
                                            <span>예약 완료</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    id="check-sms-2-1"
                                                    name="check-sms-2-1"
                                                    type="checkbox"
                                                    v-model="complete.useYn"
                                                />
                                                <label for="check-sms-2-1"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <span class="tit">
                                            <span>알림톡 사용</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`check-kakao-1-2`"
                                                    :name="`check-kakao-1-2`"
                                                    type="checkbox"
                                                    v-model="isCheckedKakao[1]"
                                                    :disabled="isToggleDisabled"
                                                />
                                                <label :for="`check-kakao-1-2`"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <select-form
                                    v-if="isCheckedKakao[1]"
                                    :select-data="['선택', ...templateList.map((template) => template.title)]"
                                    :select-value="['선택', ...templateList.map((template) => template.id)]"
                                    :selected-value="complete.template"
                                    @update:set="(templateId) => onChangeKakaoTemplate(templateId, 'complete')"
                                ></select-form>
                                <div class="com-phone-sms other">
                                    <textarea
                                        :value="complete.content"
                                        @input="isCheckedKakao[1] ? null : fnChkByte(complete, $event)"
                                        :readonly="isCheckedKakao[1]"
                                        placeholder="#{회원명} 님 #{수업일시}이 예약 되었습니다. 
감사합니다."
                                    ></textarea>
                                    <div class="info-line">
                                        <span class="num">{{ byteCalculator(complete.content) }}</span>
                                        / 2000 byte
                                    </div>
                                </div>
                                <button class="com-btn" @click="tryMessageTemplate(complete, 'RCP', 1, 'RCP')">
                                    저장
                                </button>
                            </div>
                            <div class="phone-item">
                                <div class="top-area">
                                    <div class="line">
                                        <span class="tit">
                                            <span>예약 취소</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    id="check-sms-3-1"
                                                    name="check-sms-3-1"
                                                    type="checkbox"
                                                    v-model="cancel.useYn"
                                                />
                                                <label for="check-sms-3-1"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <span class="tit">
                                            <span>알림톡 사용</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`check-kakao-1-3`"
                                                    :name="`check-kakao-1-3`"
                                                    type="checkbox"
                                                    v-model="isCheckedKakao[2]"
                                                    :disabled="isToggleDisabled"
                                                />
                                                <label :for="`check-kakao-1-3`"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <select-form
                                    v-if="isCheckedKakao[2]"
                                    :select-data="['선택', ...templateList.map((template) => template.title)]"
                                    :select-value="['선택', ...templateList.map((template) => template.id)]"
                                    :selected-value="cancel.template"
                                    @update:set="(templateId) => onChangeKakaoTemplate(templateId, 'cancel')"
                                ></select-form>
                                <div class="com-phone-sms other">
                                    <textarea
                                        :value="cancel.content"
                                        @input="isCheckedKakao[2] ? null : fnChkByte(cancel, $event)"
                                        :readonly="isCheckedKakao[2]"
                                        placeholder="#{회원명} 님 #{수업일시}이 취소 되었습니다. 
감사합니다."
                                    ></textarea>
                                    <div class="info-line">
                                        <span class="num">{{ byteCalculator(cancel.content) }}</span>
                                        / 2000 byte
                                    </div>
                                </div>
                                <button class="com-btn" @click="tryMessageTemplate(cancel, 'RCN', 2, 'RCN')">
                                    저장
                                </button>
                            </div>
                            <div class="phone-item">
                                <div class="top-area">
                                    <div class="line">
                                        <span class="tit">
                                            <span>휴강 알림</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    id="check-sms-4-1"
                                                    name="check-sms-4-1"
                                                    type="checkbox"
                                                    v-model="hu.useYn"
                                                />
                                                <label for="check-sms-4-1"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <span class="tit">
                                            <span>알림톡 사용</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`check-kakao-1-4`"
                                                    :name="`check-kakao-1-4`"
                                                    type="checkbox"
                                                    v-model="isCheckedKakao[3]"
                                                    :disabled="isToggleDisabled"
                                                />
                                                <label :for="`check-kakao-1-4`"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <select-form
                                    v-if="isCheckedKakao[3]"
                                    :select-data="['선택', ...templateList.map((template) => template.title)]"
                                    :select-value="['선택', ...templateList.map((template) => template.id)]"
                                    :selected-value="hu.template"
                                    @update:set="(templateId) => onChangeKakaoTemplate(templateId, 'hu')"
                                ></select-form>
                                <div class="com-phone-sms other">
                                    <textarea
                                        :value="hu.content"
                                        @input="isCheckedKakao[3] ? null : fnChkByte(hu, $event)"
                                        :readonly="isCheckedKakao[3]"
                                        placeholder="#{회원명}님 #{수업일시}예약하신 수업이 인원 미달로 휴강 되었습니다.
감사합니다."
                                    ></textarea>
                                    <div class="info-line">
                                        <span class="num">{{ byteCalculator(hu.content) }}</span>
                                        / 2000 byte
                                    </div>
                                </div>
                                <button class="com-btn" @click="tryMessageTemplate(hu, 'HU', 3, 'HU')">저장</button>
                            </div>
                            <div class="phone-item">
                                <div class="top-area">
                                    <div class="line">
                                        <span class="tit">
                                            <span>예약 알림</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    id="check-sms-5-1"
                                                    name="check-sms-5-1"
                                                    type="checkbox"
                                                    v-model="alarm.useYn"
                                                />
                                                <label for="check-sms-5-1"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <span class="tit">
                                            <span>알림톡 사용</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`check-kakao-1-5`"
                                                    :name="`check-kakao-1-5`"
                                                    type="checkbox"
                                                    v-model="isCheckedKakao[4]"
                                                    :disabled="isToggleDisabled"
                                                />
                                                <label :for="`check-kakao-1-5`"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <select-form
                                    v-if="isCheckedKakao[4]"
                                    :select-data="['선택', ...templateList.map((template) => template.title)]"
                                    :select-value="['선택', ...templateList.map((template) => template.id)]"
                                    :selected-value="alarm.template"
                                    @update:set="(templateId) => onChangeKakaoTemplate(templateId, 'alarm')"
                                ></select-form>
                                <div class="com-phone-sms other">
                                    <textarea
                                        :value="alarm.content"
                                        @input="isCheckedKakao[4] ? null : fnChkByte(alarm, $event)"
                                        :readonly="isCheckedKakao[4]"
                                        placeholder="#{회원명}님 #{수업일시} 수업전 알림 입니다. "
                                    ></textarea>
                                    <div class="info-line">
                                        <span class="num">{{ byteCalculator(alarm.content) }}</span>
                                        / 2000 byte
                                    </div>
                                </div>
                                <div class="bottom-area">
                                    <div class="line">
                                        <div class="input-cnt check-wrap">
                                            <div class="com-check">
                                                <input
                                                    id="check-1-1"
                                                    name="check-1"
                                                    type="checkbox"
                                                    v-model="checkboxes.all"
                                                    @change.prevent="toggleAll"
                                                />
                                                <label for="check-1-1">전체</label>
                                            </div>
                                            <div class="com-check">
                                                <input
                                                    id="check-1-2"
                                                    name="check-1"
                                                    type="checkbox"
                                                    v-model="checkboxes.individual"
                                                    @change.prevent="toggleCheckbox('individual')"
                                                />
                                                <label for="check-1-2">개인</label>
                                            </div>
                                            <div class="com-check">
                                                <input
                                                    id="check-1-3"
                                                    name="check-1"
                                                    type="checkbox"
                                                    v-model="checkboxes.duet"
                                                    @change.prevent="toggleCheckbox('duet')"
                                                />
                                                <label for="check-1-3">듀엣</label>
                                            </div>
                                            <div class="com-check">
                                                <input
                                                    id="check-1-4"
                                                    name="check-1"
                                                    type="checkbox"
                                                    v-model="checkboxes.group"
                                                    @change.prevent="toggleCheckbox('group')"
                                                />
                                                <label for="check-1-4">그룹</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <span class="tit">
                                            <span>수업 시작</span>
                                        </span>
                                        <div class="input-cnt w80">
                                            <select-form
                                                :select-data="selectFormStartHour.data"
                                                :select-value="selectFormStartHour.value"
                                                :selectedValue="alarm.hour"
                                                class="w80"
                                                @update:set="(val) => (alarm = { ...alarm, hour: val })"
                                            ></select-form>
                                        </div>
                                        <span>시간 전 발송</span>
                                    </div>
                                </div>
                                <button class="com-btn" @click="tryMessageTemplate(alarm, 'RNTI', 4, 'RNTI')">
                                    저장
                                </button>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="accordion-tit" @click="isAccordion2Open = !isAccordion2Open">
                        <span>이용권 종료 안내 - 유효기간 기준</span>
                        <span class="ico-arrow" :class="{ on: isAccordion2Open, off: !isAccordion2Open }"></span>
                    </div>
                    <div class="accordion-desc" :class="{ on: isAccordion2Open, off: !isAccordion2Open }">
                        <div class="phone-list">
                            <div
                                class="phone-item"
                                v-for="(item, index) in phoneItemsForPED"
                                :key="`${item.templateId}-${index}`"
                            >
                                <div class="top-area">
                                    <div class="line">
                                        <div class="tit line-tit-wrap">
                                            종료
                                            <div class="w80">
                                                <select-form
                                                    :select-data="selectPEDData"
                                                    :select-value="selectPEDValue"
                                                    :selected-value="item.pedTemplate || item.templateType"
                                                    @update:set="(val) => onChangePEDTemplate(val, item)"
                                                ></select-form>
                                            </div>
                                            전
                                        </div>
                                        <!-- <div class="tit line-tit-wrap">종료 7 일 전</div> -->
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`check-sms-PED-${index}`"
                                                    :name="`check-sms-PED-${index}`"
                                                    type="checkbox"
                                                    v-model="item.useYn"
                                                />
                                                <label :for="`check-sms-PED-${index}`"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <span class="tit">
                                            <span>알림톡 사용</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`check-alert-PED-${index}`"
                                                    :name="`check-alert-PED-${index}`"
                                                    type="checkbox"
                                                    v-model="isPEDChecked[index]"
                                                    :disabled="isToggleDisabled"
                                                />
                                                <label :for="`check-alert-PED-${index}`"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <select-form
                                        v-if="isPEDChecked[index]"
                                        :select-data="['선택', ...templateList.map((template) => template.title)]"
                                        :select-value="['선택', ...templateList.map((template) => template.id)]"
                                        :selectedValue="item.selectedTemplate"
                                        @update:set="(templateId) => onChangeKakaoTemplate3(templateId, item)"
                                    ></select-form>
                                </div>
                                <div class="com-phone-sms other">
                                    <textarea
                                        v-model="item.content"
                                        @input="isPEDChecked[index] ? null : fnChkByte(item, $event)"
                                        :readonly="isPEDChecked[index]"
                                        placeholder="#{회원명} 님 안녕하세요 
#{이용권명}이 곧 종료 예정입니다.
#{센터번호}로 문의주시면 친절히 상담드리겠습니다."
                                    ></textarea>
                                    <div class="info-line">
                                        <span class="num">{{ byteCalculator(item.content) }}</span>
                                        / 2000 byte
                                    </div>
                                </div>
                                <div class="bottom-area">
                                    <div class="line">
                                        <span class="tit">
                                            <span>발송 시간</span>
                                        </span>
                                        <div class="input-cnt select-wrap">
                                            <select-form
                                                :select-data="selectFormStartHour.data"
                                                :select-value="selectFormStartHour.value"
                                                :selectedValue="item.hour"
                                                class="w60"
                                                @update:set="(val) => (item.hour = val)"
                                            ></select-form>
                                            <input class="w55" disabled type="text" value="00" />
                                        </div>
                                    </div>
                                </div>
                                <div class="btn-wrap">
                                    <button class="com-btn red" @click="deleteMessageTemplate(item, item.template)">
                                        삭제
                                    </button>
                                    <button
                                        class="com-btn"
                                        @click="tryMessageTemplate(item, item.pedTemplate, index, 'PED')"
                                    >
                                        저장
                                    </button>
                                </div>
                            </div>
                            <!-- 추가 영역 -->
                            <div class="phone-item phone-add-item" @click="addPhoneItemForPED">
                                <i class="ico-plus-2"></i>
                                추가
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="accordion-tit" @click="isAccordion3Open = !isAccordion3Open">
                        <span>이용권 만료 안내 / 잔여횟수 기준</span>
                        <span class="ico-arrow" :class="{ on: isAccordion3Open, off: !isAccordion3Open }"></span>
                    </div>
                    <div class="accordion-desc" :class="{ on: isAccordion3Open, off: !isAccordion3Open }">
                        <div class="phone-list">
                            <div class="phone-item" v-for="(item, index) in phoneItemsForPEP" :key="index">
                                <div class="top-area">
                                    <div class="line">
                                        <div class="tit line-tit-wrap">
                                            종료
                                            <div class="w80">
                                                <select-form
                                                    :select-data="selectPEPData"
                                                    :select-value="selectPEPValue"
                                                    :selected-value="item.pepTemplate || item.templateType"
                                                    @update:set="(val) => onChangePEPTemplate(val, item)"
                                                ></select-form>
                                            </div>
                                            전
                                        </div>
                                        <!-- <div class="tit line-tit-wrap">종료 7 일 전</div> -->
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`check-sms-PEP-${index}`"
                                                    :name="`check-sms-PEP-${index}`"
                                                    type="checkbox"
                                                    v-model="item.useYn"
                                                />
                                                <label :for="`check-sms-PEP-${index}`"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <span class="tit">
                                            <span>알림톡 사용</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`check-alert-PEP-${index}`"
                                                    :name="`check-alert-PEP-${index}`"
                                                    type="checkbox"
                                                    v-model="isPEPChecked[index]"
                                                    :disabled="isToggleDisabled"
                                                />
                                                <label :for="`check-alert-PEP-${index}`"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <select-form
                                        v-if="isPEPChecked[index]"
                                        :select-data="['선택', ...templateList.map((template) => template.title)]"
                                        :select-value="['선택', ...templateList.map((template) => template.id)]"
                                        :selectedValue="item.kakaoTemplateId"
                                        @update:set="(templateId) => onChangeKakaoTemplate3(templateId, item)"
                                    ></select-form>
                                </div>
                                <div class="com-phone-sms other">
                                    <textarea
                                        :value="item.content"
                                        @input="isPEPChecked[index] ? null : fnChkByte(item, $event)"
                                        :readonly="isPEPChecked[index]"
                                        placeholder="#{회원명} 님 안녕하세요 
#{이용권명}이 곧 종료 예정입니다.
#{센터번호}로 문의주시면 친절히 상담드리겠습니다."
                                    ></textarea>
                                    <div class="info-line">
                                        <span class="num">{{ byteCalculator(item.content) }}</span>
                                        / 2000 byte
                                    </div>
                                </div>
                                <!-- <div class="bottom-area">
                                    <div class="line">
                                        <span class="tit">
                                            <span>발송 시간</span>
                                        </span>
                                        <div class="input-cnt select-wrap">
                                            <select-form :select-data="selectFormStartHour.data"
                                                :select-value="selectFormStartHour.value" :selectedValue="item.hour"
                                                class="w60" @update:set="val => (item.hour = val)">
                                            </select-form>
                                            <input class="w55" disabled type="text" value="00" />
                                        </div>
                                    </div>
                                </div> -->
                                <div class="btn-wrap">
                                    <button class="com-btn red" @click="deleteMessageTemplate(item, item.template)">
                                        삭제
                                    </button>
                                    <button
                                        class="com-btn"
                                        @click="tryMessageTemplate(item, item.pepTemplate, index, 'PEP')"
                                    >
                                        저장
                                    </button>
                                </div>
                            </div>
                            <div class="phone-item phone-add-item" @click="addPhoneItemForPEP">
                                <i class="ico-plus-2"></i>
                                추가
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="accordion-tit" @click="isAccordion4Open = !isAccordion4Open">
                        <span>락커 종료 안내</span>
                        <span class="ico-arrow" :class="{ on: isAccordion4Open, off: !isAccordion4Open }"></span>
                    </div>
                    <div class="accordion-desc" :class="{ on: isAccordion4Open, off: !isAccordion4Open }">
                        <div class="phone-list">
                            <div class="phone-item" v-for="(item, index) in phoneItemsForLED" :key="index">
                                <div class="top-area">
                                    <div class="line">
                                        <div class="tit line-tit-wrap">
                                            종료
                                            <div class="w90">
                                                <select-form
                                                    :select-data="selectLEDData"
                                                    :select-value="selectLEDValue"
                                                    :selected-value="item.ledTemplate || item.templateType"
                                                    @update:set="(val) => onChangeLEDTemplate(val, item)"
                                                ></select-form>
                                            </div>
                                            전
                                        </div>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`check-sms-LED-${index}`"
                                                    :name="`check-sms-LED-${index}`"
                                                    type="checkbox"
                                                    v-model="item.useYn"
                                                />
                                                <label :for="`check-sms-LED-${index}`"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <span class="tit">
                                            <span>알림톡 사용</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    :id="`check-alert-LED-${index}`"
                                                    :name="`check-alert-LED-${index}`"
                                                    type="checkbox"
                                                    v-model="isLEDChecked[index]"
                                                    :disabled="isToggleDisabled"
                                                />
                                                <label :for="`check-alert-LED-${index}`"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <select-form
                                        v-if="isLEDChecked[index]"
                                        :select-data="['선택', ...templateList.map((template) => template.title)]"
                                        :select-value="['선택', ...templateList.map((template) => template.id)]"
                                        :selectedValue="item.kakaoTemplateId"
                                        @update:set="(templateId) => onChangeKakaoTemplate3(templateId, item)"
                                    ></select-form>
                                </div>
                                <div class="com-phone-sms other">
                                    <textarea
                                        :value="item.content"
                                        @input="isLEDChecked[index] ? null : fnChkByte(item, $event)"
                                        :readonly="isLEDChecked[index]"
                                        placeholder="#{회원명} 님 안녕하세요 
락커가 곧 종료될 예정입니다.
#{센터번호}로 문의주시면 친절히 상담드리겠습니다."
                                    ></textarea>
                                    <div class="info-line">
                                        <span class="num">{{ byteCalculator(item.content) }}</span>
                                        / 2000 byte
                                    </div>
                                </div>
                                <div class="bottom-area">
                                    <div class="line">
                                        <span class="tit">
                                            <span>발송 시간</span>
                                        </span>
                                        <div class="input-cnt select-wrap">
                                            <select-form
                                                :select-data="selectFormStartHour.data"
                                                :select-value="selectFormStartHour.value"
                                                :selectedValue="item.hour"
                                                class="w60"
                                                @update:set="(val) => (item.hour = val)"
                                            ></select-form>
                                            <input class="w55" disabled type="text" value="00" />
                                        </div>
                                    </div>
                                </div>
                                <div class="btn-wrap">
                                    <button class="com-btn red" @click="deleteMessageTemplate(item, item.template)">
                                        삭제
                                    </button>
                                    <button
                                        class="com-btn"
                                        @click="tryMessageTemplate(item, item.ledTemplate, index, 'LED')"
                                    >
                                        저장
                                    </button>
                                </div>
                            </div>
                            <div class="phone-item phone-add-item" @click="addPhoneItemForLED">
                                <i class="ico-plus-2"></i>
                                추가
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="accordion-tit" @click="isAccordion5Open = !isAccordion5Open">
                        <span>기타</span>
                        <span class="ico-arrow" :class="{ on: isAccordion5Open, off: !isAccordion5Open }"></span>
                    </div>
                    <div class="accordion-desc" :class="{ on: isAccordion5Open, off: !isAccordion5Open }">
                        <div class="phone-list">
                            <!-- CASE 1 -->
                            <div class="phone-item">
                                <div class="top-area">
                                    <div class="line">
                                        <span class="tit">
                                            <span>회원 생일</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    id="check-sms-15-1"
                                                    name="check-sms-15-1"
                                                    type="checkbox"
                                                    v-model="bd1.useYn"
                                                />
                                                <label for="check-sms-15-1"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <span class="tit">
                                            <span>알림톡 사용</span>
                                        </span>
                                        <div class="check">
                                            <div class="com-design-check">
                                                <input
                                                    id="check-kakao-15-1"
                                                    name="check-kakao-15-1"
                                                    type="checkbox"
                                                    v-model="isCheckedKakao[5]"
                                                    :disabled="isToggleDisabled"
                                                />
                                                <label for="check-kakao-15-1"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <select-form
                                    v-if="isCheckedKakao[5]"
                                    :select-data="['선택', ...templateList.map((template) => template.title)]"
                                    :select-value="['선택', ...templateList.map((template) => template.id)]"
                                    :selected-value="bd1.template"
                                    @update:set="(templateId) => onChangeKakaoTemplate(templateId, 'bd1')"
                                ></select-form>
                                <div class="com-phone-sms other">
                                    <textarea
                                        :value="bd1.content"
                                        @input="isCheckedKakao[5] ? null : fnChkByte(bd1, $event)"
                                        :readonly="isCheckedKakao[5]"
                                        placeholder="#{회원명} 님 안녕하세요 
생일을 진심으로 축하 드립니다."
                                    ></textarea>
                                    <div class="info-line">
                                        <span class="num">{{ byteCalculator(bd1.content) }}</span>
                                        / 2000 byte
                                    </div>
                                </div>
                                <div class="bottom-area">
                                    <div class="line">
                                        <span class="tit">
                                            <span>발송 시간</span>
                                        </span>
                                        <div class="input-cnt select-wrap">
                                            <select-form
                                                :select-data="selectFormStartHour.data"
                                                :select-value="selectFormStartHour.value"
                                                :selectedValue="bd1.hour"
                                                @update:set="(val) => (bd1 = { ...bd1, hour: val })"
                                                class="w80"
                                            ></select-form>
                                            <input class="w55" disabled type="text" value="00" />
                                        </div>
                                    </div>
                                </div>

                                <button class="com-btn" @click="tryMessageTemplate(bd1, 'BD1', 5, 'BD1')">저장</button>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import paymentApi from '@/assets/js/paymentApi';
import { Utils } from '@/assets/js/utils';
import SelectForm from '@/components/SelectForm.vue';

export default {
    name: 'messageSendAlert',
    components: {
        SelectForm,
    },
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        templateTitles() {
            return [...this.templateList.map((template) => template.title)];
        },
        templateIds() {
            return ['', ...this.templateList.map((template) => template.id)];
        },
        selectValues() {
            return ['선택', ...this.templateList.map((template) => template.id)];
        },
        templateContent: {
            get() {
                return this.dropdowns.kakao.selectedTemplate
                    ? this.dropdowns.kakao.selectedTemplate.template_content
                    : '';
            },
            set(newValue) {
                if (this.dropdowns.kakao.selectedTemplate) {
                    this.dropdowns.kakao.selectedTemplate.template_content = newValue;
                }
            },
        },
    },
    watch: {
        selectedTemplateId(newTemplateId) {
            const selectedTemplate = this.templateList.find((template) => template.id === newTemplateId);
            if (selectedTemplate) {
                this.payPost.content = selectedTemplate.template_content;
            }
        },
        'payPost.useYn'(newValue) {
            if (newValue === false) {
                this.isCheckedKakao[0] = false;
            }
        },
        isCheckedKakao: {
            handler(newValue) {
                if (!this.isToggleDisabled && newValue[0] === true) {
                    this.payPost.useYn = true;
                }
                if (newValue[1] === true) {
                    this.complete.useYn = true;
                }
                if (newValue[2] === true) {
                    this.cancel.useYn = true;
                }
                if (newValue[3] === true) {
                    this.hu.useYn = true;
                }
                if (newValue[4] === true) {
                    this.alarm.useYn = true;
                }
                if (newValue[5] === true) {
                    this.bd1.useYn = true;
                }
            },
            deep: true,
        },
        'complete.useYn'(newValue) {
            if (newValue === false) {
                this.isCheckedKakao[1] = false;
            }
        },
        'cancel.useYn'(newValue) {
            if (newValue === false) {
                this.isCheckedKakao[2] = false;
            }
        },
        'hu.useYn'(newValue) {
            if (newValue === false) {
                this.isCheckedKakao[3] = false;
            }
        },
        'alarm.useYn'(newValue) {
            if (newValue === false) {
                this.isCheckedKakao[4] = false;
            }
        },
        'bd1.useYn'(newValue) {
            if (newValue === false) {
                this.isCheckedKakao[5] = false;
            }
        },
        phoneItemsForPED: {
            handler(newValue) {
                newValue.forEach((item, index) => {
                    if (item.useYn === false) {
                        this.isPEDChecked[index] = false;
                    }
                });
            },
            deep: true,
        },
        isPEDChecked: {
            handler(newValue) {
                newValue.forEach((value, index) => {
                    if (value === true) {
                        this.phoneItemsForPED[index].useYn = true;
                    } else {
                    }
                });
            },
            deep: true,
        },
        phoneItemsForPEP: {
            handler(newValue) {
                newValue.forEach((item, index) => {
                    if (item.useYn === false) {
                        this.isPEPChecked[index] = false;
                    }
                });
            },
            deep: true,
        },
        isPEPChecked: {
            handler(newValue) {
                newValue.forEach((value, index) => {
                    if (value === true) {
                        this.phoneItemsForPEP[index].useYn = true;
                    }
                });
            },
            deep: true,
        },

        phoneItemsForLED: {
            handler(newValue) {
                newValue.forEach((item, index) => {
                    if (item.useYn === false) {
                        this.isLEDChecked[index] = false;
                    }
                });
            },
            deep: true,
        },
        isLEDChecked: {
            handler(newValue) {
                newValue.forEach((value, index) => {
                    if (value === true) {
                        this.phoneItemsForLED[index].useYn = true;
                    }
                });
            },
            deep: true,
        },
        options: {
            immediate: true,
            handler() {
                const defaultOption =
                    this.options.find((o) => o.is_sub_number) ||
                    this.options.find((o) => o.is_present) ||
                    this.options[0];
                if (defaultOption) this.selectedNumber = defaultOption;
            },
        },
    },
    filters: {
        formatDate(value) {
            if (value) {
                const date = new Date(value);
                const year = date.getFullYear();
                const month = ('0' + (date.getMonth() + 1)).slice(-2);
                const day = ('0' + date.getDate()).slice(-2);
                return `${year}-${month}-${day}`;
            }
            return '';
        },
    },
    data() {
        const selectPEDData = ['선택', '당일', ...Array.from({ length: 31 }, (_, i) => `${i + 1}일`)];
        const selectPEDValue = ['선택', 'PED0', ...Array.from({ length: 31 }, (_, i) => `PED${i + 1}`)];
        const selectPEPData = ['선택', '0회', ...Array.from({ length: 10 }, (_, i) => `${i + 1}회`)];
        const selectPEPValue = ['선택', 'PEP0', ...Array.from({ length: 10 }, (_, i) => `PEP${i + 1}`)];
        const selectLEDData = ['선택', '당일', ...Array.from({ length: 10 }, (_, i) => `${i + 1}일`)];
        const selectLEDValue = ['선택', 'LED0', ...Array.from({ length: 10 }, (_, i) => `LED${i + 1}`)];
        const periodInfo = {
            선택: {
                hour: '00',
                templateName: '',
            },
            당일: {
                hour: '00',
                templateName: '유효기간종료당일',
            },
        };

        for (let i = 1; i <= 31; i++) {
            periodInfo[`${i}일`] = {
                hour: '00',
                templateName: `유효기간종료${i}일전`,
            };
        }
        const pepInfo = {
            선택: {
                hour: '00',
                templateName: '',
            },
            당일: {
                hour: '00',
                templateName: '잔여횟수종료당일',
            },
        };
        for (let i = 1; i <= 31; i++) {
            pepInfo[`${i}일`] = {
                hour: '00',
                templateName: `잔여횟수종료${i}일전`,
            };
        }
        const ledInfo = {
            선택: {
                hour: '00',
                templateName: '',
            },
            당일: {
                hour: '00',
                templateName: '락커종료당일',
            },
        };
        for (let i = 1; i <= 10; i++) {
            ledInfo[`${i}일`] = {
                hour: '00',
                templateName: `락커종료${i}일전`,
            };
        }
        return {
            centerId: '',
            payPost: {
                templateName: '결제등록',
            },
            complete: {
                templateName: '예약완료',
            },
            cancel: {
                templateName: '예약취소',
            },
            hu: {
                templateName: '휴강알림',
            },
            alarm: {
                templateName: '예약알림',
                hour: '00',
            },
            bd1: {
                templateName: '생일알림',
                hour: '00',
            },
            selectPEDData,
            selectPEDValue,
            periodInfo, //periodInfo[selectPEDValue].hour
            selectFormStartHour: {
                data: [],
                value: [],
                selectedValue: '00',
            },
            selectPEPData,
            selectPEPValue,
            pepInfo,
            selectLEDData,
            selectLEDValue,
            ledInfo,
            centerInfo: {},
            isAccordion1Open: true,
            isAccordion2Open: false,
            isAccordion3Open: false,
            isAccordion4Open: false,
            isAccordion5Open: false,
            phoneItems: [
                // 초기 phone-item 객체
            ],
            sortSend: [],
            sortSendNo: [],
            sendName: '',
            sendNo: '',
            endGuide: [{}],
            selectedTemplateType: '',
            isChecked: [],
            isPEDChecked: [],
            isLEDChecked: [],
            isPEPChecked: [],
            phoneItemsForPED: [],
            phoneItemsForPEP: [],
            phoneItemsForLED: [],
            templateList: [],
            isCheckedKakao: [false, false, false, false, false, false],
            defaultSendNo: '',

            isOpen: false,
            testSelected: null,
            options: [],
            selectedNumber: null,
            selectedTemplate: null,

            checkboxes: {
                all: false,
                individual: false,
                duet: false,
                group: false,
            },
            content: '',
            selectedTemplateId: null,
            dropdowns: {
                kakao: {
                    isOpen: false,
                    selectedTemplate: null,
                },
            },
            pepTemplate: '',
            pedTemplate: '',
            ledTemplate: '',
            isToggleDisabled: false,
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.init();
        this.getMessageTemplateList()
            .then((response) => {
                this.RNTI = response.data.filter((template) => template.templateType == 'RNTI');
                this.setSendCheckbox();
            })
            .catch((error) => {
                console.error(error);
            });
        this.refreshTemplates();
    },
    methods: {
        toggleDropdownTemplate(dropdownName) {
            this.dropdowns[dropdownName].isOpen = !this.dropdowns[dropdownName].isOpen;
        },
        selectTemplateOption(event, dropdownKey, template) {
            event.stopPropagation(); // 드롭다운이 닫히는 것을 방지
            this.dropdowns[dropdownKey].selectedTemplate = template;
            this.dropdowns[dropdownKey].isOpen = false; // 드롭다운 닫기
        },
        setSendCheckbox() {
            if (this.RNTI && this.RNTI[0]) {
                if (this.RNTI[0].sendTypeCd) {
                    let checkValue = this.RNTI[0].sendTypeCd;
                    if (checkValue.includes('A') || !checkValue) {
                        this.checkboxes.all = true;
                        this.toggleAll();
                    }
                    if (checkValue.includes('P,O')) {
                        this.checkboxes.individual = true;
                    }
                    if (checkValue.includes('D')) {
                        this.checkboxes.duet = true;
                    }
                    if (checkValue.includes('G')) {
                        this.checkboxes.group = true;
                    }
                } else {
                    // 값이 없거나 널이라면.
                    this.checkboxes.all = true;
                }
            }
        },
        toggleAll() {
            const isChecked = this.checkboxes.all;
            Object.keys(this.checkboxes).forEach((key) => {
                this.checkboxes[key] = isChecked;
            });
        },
        toggleCheckbox(key) {
            this.checkboxes.all = ['individual', 'duet', 'group'].every((checkboxKey) => {
                return this.checkboxes[checkboxKey];
            });
        },
        async init() {
            try {
                const { selectFormStartHour } = this;
                const { data } = await this.getCenterInfo();
                this.centerInfo = data;
                await Promise.allSettled([this.onCallNumber()]);
                // 시작 시간 : 시
                for (let h = 0; h <= 24; h++) {
                    const hour = h.toString().padStart(2, '0');
                    selectFormStartHour.data.push(hour);
                    selectFormStartHour.value.push(hour);
                }
                this.onMessageTemplateList();
                this.bindPhoneItemsForPED();
                this.getTemplateList(); // 카카오 메시지 템플릿 가져오기
                this.loadCallNumbers(), (this.sendNo = this.defaultSendNo);
                this.sendName = this.sortSend[0];
            } catch (error) {
                console.log(error);
            }
        },
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        selectOption(option, event) {
            event.stopPropagation(); // 이벤트 버블링 중지
            this.selectedNumber = option;
            this.sendNo = option.value;
            this.isOpen = false;
        },
        async loadCallNumbers() {
            try {
                const response = await paymentApi.post(`admin/api/center-phone/${this.centerId}/list`, {
                    page: 1,
                    skip: 10,
                });
                // 응답 데이터를 드롭다운 옵션 형식으로 매핑
                this.options = response.data.list
                    .filter((item) => item.is_validated === 'APPROVED') // is_validated 값이 "APPROVED"인 항목만 선택
                    .map((item) => ({
                        label: item.send_nm,
                        value: item.send_no,
                        is_present: item.is_present,
                        is_sub_number: item.is_sub_number,
                    }));

                // 기본 선택값 설정
                const defaultOption =
                    this.options.find((o) => o.is_sub_number) ||
                    this.options.find((o) => o.is_present) ||
                    this.options[0];
                if (defaultOption) this.selectedNumber = defaultOption;

                console.log('loadCallNumbers', this.options);
            } catch (error) {
                console.error(error);
            }
        },
        isHighlighted(option) {
            // 강조 표시가 필요한 조건을 여기에 정의
            return option && option.is_present;
        },
        async saveNumber() {
            try {
                const sendNumber = this.selectedNumber ? this.selectedNumber.value.replace(/-/g, '') : '';
                if (!sendNumber) {
                    alert('발신번호를 선택해주세요.');
                    return;
                }
                await paymentApi.put(`/admin/api/center-phone/${this.centerId}/set-sub-number`, { sendNumber });
                alert('저장되었습니다.');
            } catch (error) {
                console.error('API 요청 실패:', error);
            }
        },
        onChangeTemplate(val, item) {
            item.template = val;
        },
        onChangePEPTemplate(val, item) {
            item.pepTemplate = val;
        },

        onChangePEDTemplate(val, item) {
            item.pedTemplate = val;
        },

        onChangeLEDTemplate(val, item) {
            item.ledTemplate = val;
        },

        mapTemplatesToItems(templates) {
            return templates.map((template) => ({
                template: template.templateType,
                messageTemplateId: template.messageTemplateId,
                useYn: template.useYn,
                content: template.content,
                hour: template.sendTime ? template.sendTime.slice(0, 2) : '09',
            }));
        },
        addPhoneItemForPED() {
            this.phoneItemsForPED.push(this.createNewItem('선택'));
        },
        addPhoneItemForPEP() {
            this.phoneItemsForPEP.push(this.createNewItem('선택'));
        },
        addPhoneItemForLED() {
            this.phoneItemsForLED.push(this.createNewItem('선택'));
        },
        createNewItem(templateType) {
            return { template: templateType, useYn: true, content: '', hour: '00' };
        },
        async bindPhoneItemsForPED() {
            try {
                await this.getTemplateList(); // 카카오톡 템플릿 리스트를 먼저 가져옵니다.
                const { data } = await this.getMessageTemplateList(); // 메시지 템플릿 리스트를 가져옵니다.
                // "PED"로 시작하는 templateType만 필터링하고 필요한 형태로 매핑
                const phoneItemsForPED = data
                    .filter((template) => template.templateType && template.templateType.startsWith('PED'))
                    .map((template) => {
                        // kakao_talk_template_id에 해당하는 템플릿을 templateList에서 찾습니다.
                        const matchedTemplate = this.templateList.find((t) => t.id === template.kakao_talk_template_id);
                        // 찾은 템플릿의 내용을 사용하거나, 없으면 기존 template.content 사용
                        const content = matchedTemplate ? matchedTemplate.template_content : template.content;
                        return {
                            content: content,
                            hour: template.sendTime ? template.sendTime.substring(0, 2) : '00',
                            kakaoTemplateId: template.kakao_talk_template_id,
                            messageTemplateId: template.messageTemplateId,
                            sendTime: template.sendTime,
                            senderName: template.senderName,
                            senderNo: template.senderNo,
                            smsType: template.smsType,
                            pedTemplate: template.templateType,
                            templateName: template.templateName,
                            templateType: template.templateType,
                            useYn: template.useYn,
                            selectedTemplate: template.kakao_talk_template_id,
                        };
                    });

                // 바인딩된 배열을 Vue 인스턴스 데이터에 할당
                this.phoneItemsForPED = [...phoneItemsForPED.sort((a, b) => (a.templateId > b.templateId ? 1 : 0))];
                this.isPEDChecked = this.phoneItemsForPED.map((item) => !!item.kakaoTemplateId);

                console.log('##', this.phoneItemsForPED, this.isPEDChecked);

                const phoneItemsForPEP = data
                    .filter((template) => template.templateType && template.templateType.startsWith('PEP'))
                    .map((template) => {
                        const matchedTemplate = this.templateList.find((t) => t.id === template.kakao_talk_template_id);
                        const content = matchedTemplate ? matchedTemplate.template_content : template.content;
                        return {
                            content: content,
                            hour: template.sendTime ? template.sendTime.substring(0, 2) : '00',
                            kakaoTemplateId: template.kakao_talk_template_id,
                            messageTemplateId: template.messageTemplateId,
                            sendTime: template.sendTime,
                            senderName: template.senderName,
                            senderNo: template.senderNo,
                            smsType: template.smsType,
                            pepTemplate: template.templateType,
                            templateName: template.templateName,
                            templateType: template.templateType,
                            useYn: template.useYn,
                            selectedTemplate: template.kakao_talk_template_id,
                        };
                    });
                this.phoneItemsForPEP = [...phoneItemsForPEP.sort((a, b) => (a.templateId > b.templateId ? 1 : 0))];
                this.isPEPChecked = this.phoneItemsForPEP.map((item) => !!item.kakaoTemplateId);

                const phoneItemsForLED = data
                    .filter((template) => template.templateType && template.templateType.startsWith('LED'))
                    .map((template) => {
                        const matchedTemplate = this.templateList.find((t) => t.id === template.kakao_talk_template_id);
                        const content = matchedTemplate ? matchedTemplate.template_content : template.content;
                        return {
                            content: content,
                            hour: template.sendTime ? template.sendTime.substring(0, 2) : '00',
                            kakaoTemplateId: template.kakao_talk_template_id,
                            messageTemplateId: template.messageTemplateId,
                            sendTime: template.sendTime,
                            senderName: template.senderName,
                            senderNo: template.senderNo,
                            smsType: template.smsType,
                            ledTemplate: template.templateType,
                            templateName: template.templateName,
                            templateType: template.templateType,
                            useYn: template.useYn,
                            selectedTemplate: template.kakao_talk_template_id,
                        };
                    });
                this.phoneItemsForLED = [...phoneItemsForLED.sort((a, b) => (a.templateId > b.templateId ? 1 : 0))];
                this.isLEDChecked = this.phoneItemsForLED.map((item) => !!item.kakaoTemplateId);

                //this.isLEDChecked = this.phoneItemsForLED.map(item => !!item.kakaoTemplateId);
            } catch (error) {
                console.error('카카오톡 템플릿 리스트 바인딩 중 오류 발생:', error);
            }
        },
        async linkKakaoTemplate(messageTemplateId, kakaoTemplateId, isLink = true) {
            // Check - Need Alert Message?

            const payload = {
                messageTemplateId,
                kakaoTemplateId,
            };
            if (isLink) {
                await paymentApi.post(`/admin/api/kakaotalk/link/templates/${this.centerId}`, payload);
            } else {
                await paymentApi.put(`/admin/api/kakaotalk/unlink/templates/${this.centerId}`, payload);
            }
        },
        isCheckedUseKakao(index, type) {
            switch (type) {
                case 'LED':
                    return this.isLEDChecked[index];
                case 'PEP':
                    return this.isPEPChecked[index];
                case 'PED':
                    return this.isPEDChecked[index];
                case 'RNTI':
                    return this.isCheckedKakao[4];
                case 'HU':
                    return this.isCheckedKakao[3];
                case 'BD1':
                    return this.isCheckedKakao[5];
                case 'PRG':
                    return this.isCheckedKakao[0];
                case 'RCP':
                    return this.isCheckedKakao[1];
                case 'RCN':
                    return this.isCheckedKakao[2];
                default:
                    return false;
            }
        },
        async onMessageTemplateList() {
            try {
                await this.getTemplateList();
                const { data } = await this.getMessageTemplateList();
                const templateToIndexMapping = {
                    PRG: 0,
                    RCP: 1,
                    RCN: 2,
                    HU: 3,
                    RNTI: 4,
                    BD1: 5,
                };
                this.isCheckedKakao = Array(5).fill(false);
                const templates = {
                    PRG: 'payPost', // 결제
                    RCP: 'complete', // 예약완료
                    RCN: 'cancel', // 예약취소
                    RNTI: 'alarm', // 예약알람
                    HU: 'hu', // 휴강
                    BD1: 'bd1', // 생일
                };
                const templateTypes = [];
                for (let i = 1; i <= 31; i++) {
                    templates[`PED${i}`] = `period${i}`;
                    templates[`LED${i}`] = `locker${i}`;
                    templateTypes.push(`PED${i}`);
                    templateTypes.push(`LED${i}`);
                }
                for (let i = 1; i <= 10; i++) {
                    templates[`PEP${i}`] = `periodC${i}`;
                    templateTypes.push(`PEP${i}`);
                }

                data.forEach((template) => {
                    const tplName = templates[template.templateType];
                    const convertedTemplateType = this.convertTemplateType(template.templateType);
                    if (templateTypes.includes(template.templateType)) {
                        template.hour = Utils.isEmpty(template.sendTime) ? '09' : template.sendTime.slice(0, 2);
                    }
                    this[tplName] = template;
                    this[convertedTemplateType] = template.templateType; // 변환된 templateType 설정
                    // kakao_talk_template_id가 있는 경우 isCheckedKakao 업데이트
                    const index = templateToIndexMapping[template.templateType];

                    if (typeof template.kakao_talk_template_id === 'number' && typeof index === 'number') {
                        this.isCheckedKakao[index] = true;
                        this.isPEDChecked[index] = true;
                        this.isLEDChecked[index] = true;
                        this.isPEPChecked[index] = true;
                    }
                    //kakao_talk_template_id에 해당하는 템플릿을 templateList에서 찾기
                    if (typeof template.kakao_talk_template_id === 'number') {
                        const matchedTemplate = this.templateList.find((t) => t.id === template.kakao_talk_template_id);
                        if (matchedTemplate) {
                            // 매칭된 템플릿이 있으면, 해당 Vue 인스턴스 데이터의 template 속성 업데이트
                            this[tplName].template = matchedTemplate.id;
                            this[tplName].content = matchedTemplate.template_content;
                        }
                    }
                    // 휴강 알림과 예약 알림의 시간 값 설정
                    if (template.templateType === 'BD1' || template.templateType === 'RNTI') {
                        this[tplName].hour = Utils.isEmpty(template.sendTime) ? '09' : template.sendTime.slice(0, 2);
                    }
                });
            } catch (error) {
                console.error(error);
            }
        },
        convertTemplateType(templateType) {
            const prefix = templateType.slice(0, 3).toLowerCase();
            return `${prefix}Template`;
        },
        getMessageTemplateList() {
            return api.get(`/admin/api/center/${this.centerId}/message/template`, {
                params: {
                    auto: true,
                },
            });
        },
        //카카오 템플릿 가져오기
        async getTemplateList() {
            try {
                const response = await paymentApi.get(`/admin/api/kakaotalk/list/template/${this.centerId}`);
                // inspection_status가 'APR'이고, send_method가 'auto'이며 useYn이 true인 템플릿만 필터링
                this.templateList =
                    response.data.filter(
                        (template) =>
                            template.inspection_status === 'APR' &&
                            template.send_method === 'auto' &&
                            template.use_yn === true
                    ) || [];
            } catch (error) {
                console.error('템플릿 리스트 불러오기 실패:', error);
            }
        },

        async tryMessageTemplate(val, code, index, type = null) {
            let messageTemplateSuccess = false;
            let kakaoTemplateSuccess = false;

            console.log('val 저장:', val);
            console.log('code 저장:', code);
            console.log('index 저장:', index);
            console.log('타입:', type);
            try {
                const isChecked = this.isCheckedUseKakao(index, type);

                const { kakaoTemplateId, messageTemplateId } = val;

                if (isChecked && !kakaoTemplateId) {
                    alert('선택된 카카오 템플릿이 없습니다.');
                    return;
                }

                console.log('@@@test', isChecked, type);

                if (type === 'RNTI') {
                    console.log('Handling RNTI type');
                    if (val.messageTemplateId && val.kakaoTemplateId) {
                        try {
                            await this.linkKakaoTemplate(val.messageTemplateId, val.kakaoTemplateId, true);
                            console.log('RNTI: 알림톡 템플릿 연결 성공');
                        } catch (error) {
                            console.error('RNTI: 알림톡 템플릿 연결 실패', error);
                        }
                    }
                }
                if (type) {
                    if (messageTemplateId) {
                        if (isChecked) {
                            if (!!kakaoTemplateId) {
                                this.linkKakaoTemplate(messageTemplateId, kakaoTemplateId, true);
                                console.log('알림톡 템플릿 저장되었습니다');
                            } else {
                                alert('선택된 알림톡 템플릿이 없습니다.');
                                return;
                            }
                        } else {
                            this.linkKakaoTemplate(messageTemplateId, kakaoTemplateId, false);
                            console.log('알림톡 템플릿 연결 해제 완료');
                        }
                    }
                } else {
                    // 타입이 제공되지 않았을 때의 기본 동작
                    if (val.messageTemplateId && !val.kakaoTemplateId) {
                        await paymentApi.put(`/admin/api/kakaotalk/unlink/templates/${this.centerId}`, {
                            messageTemplateId: val.messageTemplateId,
                        });
                        console.log('알림톡 템플릿 연결 해제 완료');
                    }
                }
                // 메세지 템플릿 저장 혹은 수정
                if (val.messageTemplateId) {
                    messageTemplateSuccess = await this.editMessageTemplate(val);
                    //messageTemplateSuccess = true;
                } else {
                    const { data } = await this.postMessageTemplate(val, code);

                    if (isChecked && !!kakaoTemplateId)
                        this.linkKakaoTemplate(data.messageTemplateId, kakaoTemplateId, true);

                    if (data != undefined) {
                        messageTemplateSuccess = true;
                    }
                }
                // 결과에 따른 사용자 알림
                if (messageTemplateSuccess || kakaoTemplateSuccess) {
                    alert('저장되었습니다.');
                }
                // 메시지 템플릿 리스트 갱신

                await this.getTemplateList(); // 카카오 메시지 템플릿 가져오기
                await this.onMessageTemplateList();
                await this.bindPhoneItemsForPED();

                // await this.onMessageTemplateList();
                // await this.bindPhoneItemsForPED();
            } catch (error) {
                console.error('오류 발생:', error);
                alert('저장 과정에 오류가 발생했습니다.');
            }
        },
        updatePreviewContent() {
            if (this.selectedTemplate) {
                // selectedTemplate가 있는지 확인
                this.previewContent = this.selectedTemplate.template_content;
            }
        },
        onChangeKakaoTemplate3(templateId, item) {
            const selectedTemplate = this.templateList.find((template) => template.id === templateId);
            if (selectedTemplate) {
                item.content = selectedTemplate.template_content;
                item.kakaoTemplateId = selectedTemplate.id;
                item.template = selectedTemplate.id;
                item.selectedTemplate = selectedTemplate.id;
                // this[item].content = selectedTemplate.template_content;
                // this[item].kakaoTemplateId = selectedTemplate.id;
                // this[item].template = selectedTemplate.id;
            }
        },
        onChangeKakaoTemplate(templateId, targetModel) {
            console.log('Changing Kakao template:', templateId, targetModel);
            const selectedTemplate = this.templateList.find((template) => template.id === templateId);
            if (selectedTemplate) {
                this[targetModel].content = selectedTemplate.template_content;
                this[targetModel].kakaoTemplateId = selectedTemplate.id;
                this[targetModel].template = selectedTemplate.id;
                console.log(`Updated ${targetModel}:`, this[targetModel]);
            }
        },
        onChangeTemplateSet(selectedTemplateId) {
            this.selectedTemplateTitle = selectedTemplateId;
        },

        async saveKakaoTemplate(templateId, messageTemplateId) {
            try {
                const data = {
                    kakaoTemplateId: templateId,
                    messageTemplateId: messageTemplateId,
                };
                const response = await paymentApi.post(`/admin/api/kakaotalk/link/templates/${this.centerId}`, data);
                console.log('저장 성공', response);
                //alert('saveKakaotemplate: 저장되었습니다.');
            } catch (error) {
                console.error('저장 실패', error);
                alert('저장에 실패하였습니다.');
            }
        },

        // 등록
        async postMessageTemplate(val, code) {
            console.log('등록val:', val);
            console.log('등록code:', code);
            // 스웨거 검색: 메시지템플릿 등록
            // 첫 번째 API 호출: 전화번호 목록 가져오기
            let senderNo = this.centerInfo.telNo; // 기본값 설정
            try {
                //내용없이 등록시 에러 발생하여 추가
                if (!val.content) {
                    alert('내용을 등록해 주세요.');
                    return false;
                }

                const response = await paymentApi.post(`/admin/api/center-phone/${this.centerId}/list/`, {
                    page: 1,
                    skip: 10,
                });
                const phoneList = response.data.list;
                //승인된 발신번호가 없으면 저장안되도록 변경
                const progressItem = phoneList.find((item) => item.is_validated === 'APPROVED');
                if (!progressItem) {
                    alert('승인된 발신번호가 없습니다. 발신번호를 등록해주세요.');
                    return false;
                } else {
                    senderNo = progressItem.send_no;
                }

                const subNumberItem = phoneList.find((item) => item.is_sub_number === true);
                if (subNumberItem) {
                    senderNo = subNumberItem.send_no;
                } else {
                    const presentItem = phoneList.find((item) => item.is_present === true);
                    if (presentItem) {
                        senderNo = presentItem.send_no;
                    }
                }
            } catch (error) {
                console.error('전화번호 목록 가져오기 실패:', error);
            }
            let sendTypeCd = '';
            if (val.templateType == 'RNTI' && val.sendTypeCd) {
                if (this.checkboxes.all) {
                    sendTypeCd = 'A';
                } else {
                    let types = [];
                    if (this.checkboxes.individual) types.push('P,O');
                    if (this.checkboxes.duet) types.push('D');
                    if (this.checkboxes.group) types.push('G');

                    sendTypeCd = types.join(',');
                }
            }

            return api.post(`/admin/api/center/${this.centerId}/message/template`, {
                centerId: this.centerId,
                senderNo: senderNo,
                senderName: '자동', // 어떤값을 입력해야되는지.
                templateType: code,
                templateName: code,
                smsType: this.byteCal(val.content) > 90 ? 'L' : 'S',
                title: val.title,
                content: val.content,
                sendTime: Utils.isEmpty(val.hour) ? '' : `${val.hour}00`,
                useYn: val.useYn ? val.useYn : false,
                sendTypeCd: sendTypeCd,
            });
        },
        // 수정시
        async editMessageTemplate(val) {
            console.log('수정val:', val);
            const params = val;
            delete params.kakao_talk_template_id;
            params.sendTime = Utils.isEmpty(val.hour) ? '' : `${val.hour}00`;
            params.senderName = '자동';
            params.smsType = this.byteCal(val.content) > 90 ? 'L' : 'S';
            let senderNo = this.centerInfo.telNo;

            const response = await paymentApi.post(`/admin/api/center-phone/${this.centerId}/list/`, {
                page: 1,
                skip: 10,
            });
            const phoneList = response.data.list;
            //승인된 발신번호가 없으면 저장안되도록 변경
            const progressItem = phoneList.find((item) => item.is_validated === 'APPROVED');
            if (!progressItem) {
                alert('승인된 발신번호가 없습니다. 발신번호를 등록해주세요.');
                return false;
            } else {
                senderNo = progressItem.send_no;
            }

            const { data } = await api.get(`/admin/api/center/${this.centerId}/message/phone`);
            //이름이 잘못되있어 undifine으로 들어감 백엔드에서 세팅되는 값으로 되는것으로 놔두라고함 dan
            if (data.length > 0) senderNo = data[0].sortSendNo;
            params.senderNo = senderNo;
            if (val.templateType == 'RNTI') {
                if (this.checkboxes.all) {
                    params.sendTypeCd = 'A';
                } else {
                    let types = [];
                    if (this.checkboxes.individual) types.push('P,O');
                    if (this.checkboxes.duet) types.push('D');
                    if (this.checkboxes.group) types.push('G');

                    params.sendTypeCd = types.join(',');
                }
            }
            console.log('apu params', params);

            // pepTemplate, pedTemplate, ledTemplate 값이 있으면 templateName과 templateType에 할당
            if (val.pepTemplate) {
                params.templateName = val.pepTemplate;
                params.templateType = val.pepTemplate;
            } else if (val.pedTemplate) {
                params.templateName = val.pedTemplate;
                params.templateType = val.pedTemplate;
            } else if (val.ledTemplate) {
                params.templateName = val.ledTemplate;
                params.templateType = val.ledTemplate;
            }

            // 스웨거 검색: 메시지템플릿 수정
            return api.put(`/admin/api/center/${this.centerId}/message/template/${val.messageTemplateId}`, params);
        },
        // 삭제
        async deleteMessageTemplate(val) {
            if (val.messageTemplateId) {
                await api.delete(`/admin/api/center/${this.centerId}/message/template/${val.messageTemplateId}`);
                console.log('삭제되었습니다.', val.messageTemplateId);
            }

            // 클라이언트 측에서 항목 제거
            this.removePhoneItem(val);

            alert('삭제되었습니다.');
            await this.getTemplateList(); // 카카오 메시지 템플릿 가져오기
            await this.onMessageTemplateList();
            await this.bindPhoneItemsForPED();
        },
        removePhoneItem(item) {
            const index = this.phoneItemsForPED.indexOf(item);
            if (index !== -1) {
                this.phoneItemsForPED.splice(index, 1);
            } else {
                const index = this.phoneItemsForPEP.indexOf(item);
                if (index !== -1) {
                    this.phoneItemsForPEP.splice(index, 1);
                } else {
                    const index = this.phoneItemsForLED.indexOf(item);
                    if (index !== -1) {
                        this.phoneItemsForLED.splice(index, 1);
                    }
                }
            }
        },
        // 바이트 수 계산(1)
        byteCal(byte) {
            if (byte !== undefined) {
                const pattern = /[\u0000-\u007f]|([\u0080-\u07ff]|(.))/g;
                const result = byte.replace(pattern, '$&$1$2').length;
                if (result > 2000) {
                    alert('내용은 2000byte를 넘을수 없습니다.');
                    return result;
                }
                return result;
            }
        },
        // 바이트 수 계산(2)
        byteCalculator(val) {
            // console.log('넘어오는값',val);
            if (val == undefined || val == '') {
                // undefiend인 경우!
                val = '';
            }
            let str = val; // 내용
            const str_len = str.length; // 길이
            let rbyte = 0;
            let rlen = 0;
            let one_char = '';
            // let str ="";
            let maxByte = 2000;

            for (let i = 0; i < str_len; i++) {
                one_char = str.charAt(i); // char 단위로 구분해서 바이트 구분
                if (escape(one_char).length > 4) {
                    rbyte += 2; // 한글2바이트
                } else {
                    rbyte++; // 영문등 나머지
                }
                if (rbyte <= maxByte) {
                    rlen = i + 1; // return 할 문자열 갯수
                }
            }
            // 넘어가는 글자는 자른다
            if (rbyte > maxByte) {
                alert(`${maxByte}자를 초과 입력 할 수 없습니다.`);
                str = str.substr(0, rlen);
                val = str;
            } else if ((maxByte = 0)) {
                alert('문자 형식을 선택 해주세요.');
            } else {
                return rbyte;
            }
        },
        fnChkByte(value, e) {
            value.content = e.target.value;
        },
        checkDate(e, name) {
            name.hour = e;
            console.log(e, name);
        },
        getCenterInfo() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },
        copy(event) {
            navigator.clipboard.writeText(event.target.innerText);
            return false;
        },
        async onCallNumber() {
            try {
                this.isLoading = true;
                const { data } = await this.getMessageChargeCall();
                data.list.forEach((g) => {
                    let senderName;
                    if (g.is_sub_number) {
                        senderName = g.send_nm;
                    } else if (g.is_present) {
                        senderName = `${g.send_nm} (대표)`;
                    } else {
                        senderName = g.send_nm;
                    }
                    const formattedSenderNo = this.formatPhoneNumber(g.send_no);
                    const senderInfo = `${senderName} ${formattedSenderNo}`;
                    this.sortSend.push(senderInfo);
                    this.sortSendNo.push(formattedSenderNo);
                });
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        getMessageChargeCall() {
            return paymentApi.post(`/admin/api/center-phone/${this.centerId}/list`, {
                page: 1,
                skip: 100,
            });
        },
        formatPhoneNumber(value) {
            if (value) {
                let phone = value.replace(/[^0-9]/g, ''); // 숫자가 아닌 문자 제거
                if (phone.length === 11) {
                    return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                } else if (phone.length === 10) {
                    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                } else if (phone.length === 9) {
                    return phone.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                }
            }
            return value;
        },
        refreshTemplates() {
            paymentApi
                .post(`/admin/api/kakaotalk/status/template/${this.centerId}`)
                .then((response) => {})
                .catch((error) => {
                    console.error(error);
                    if (error.response.data.error && error.response.data.error.name === 'NotFoundError') {
                        this.isCheckedKakao[0] = false;
                        this.isToggleDisabled = true;
                    }
                });
        },
        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
    },
};
</script>
<style lang="scss"></style>
